import { map, type Observable } from 'rxjs';

import type { Vehicle } from 'src/app/api/owcc/models';
import type { DeeplinkDto } from 'src/app/api/vehicle-deeplinks/models';
import { DeeplinksService } from 'src/app/api/vehicle-deeplinks/services';
import { appInject } from 'src/app/app-injector';

export const fetchDeeplink = (
  country: string,
  language: string,
  vehicle: Vehicle,
  onlineCode: string,
  productType: 'TEST_DRIVE' | 'ONLINE_SHOP'
): Observable<DeeplinkDto> =>
  appInject<DeeplinksService>(DeeplinksService)
    .getDeeplinksByBaumusterAndModelYear({
      market: country,
      language,
      baumuster: vehicle.baumuster || '',
      modelYear: vehicle.modelYear || '',
      productTypes: [productType],
      changeYear: vehicle.changeYear,
      nationalSalesType: vehicle.nst,
      onlineCode
    })
    .pipe(map(result => result[productType]));
